import type { DefaultRootState as ReactReduxDefaultRootState } from "react-redux";
import { combineReducers } from "redux";
import groupManagement from "group_management/reducers";
import type { IGroupManagementState } from "group_management/types";
import context from "reducers/context";

import olo from "reducers/olo";
import superUser, { type ISuperUserState } from "reducers/super_user";
import user, { type IUserState } from "reducers/user";
import users from "reducers/users";

import type { IContext } from "types/context";
import type { IOLOState } from "types/olo";
import type { IUsers } from "types/user";

declare module "react-redux" {
  interface DefaultRootState {
    groupManagement: IGroupManagementState;
    context: IContext;
    olo: IOLOState;
    user: IUserState;
    users: IUsers;
    superUser: ISuperUserState;
  }
}

const reducers = combineReducers<ReactReduxDefaultRootState>({
  groupManagement,
  context,
  olo,
  user,
  users,
  superUser,
});

export default reducers;
